/*
  Какие ПОЛЯ сервер не принял и почему - объект «имя поля: причина».

  Форма ставит эту причину под самим полем. Перечень приходит с сервера
  (`backend/app/api/validation.py`): собственных правил проверки кабинет не
  заводит, иначе появился бы второй источник правды, и он разошёлся бы с первым
  при первой же правке схемы.

  Пустой объект означает «сервер полей не назвал» - тогда человек читает общее
  сообщение, как и прежде.

  Лежит отдельным модулем (26.10.2026): функция чистая, не ходит в сеть, а проверки
  экранов подменяют `client.js` целиком - в такой подмене её не было бы.
  `client.js` по-прежнему отдаёт её под тем же именем.
*/
export function fieldErrors(error) {
  const fields = error?.details?.fields
  return fields && typeof fields === 'object' ? fields : {}
}

/*
  Рамка ошибки без текста под полем - для полей в строке с кнопкой (30.10.2026): пояснение под
  таким полем удлиняет его и сбивает линию строки (правило 6г скилла `frontend`), поэтому
  причина остаётся в плашке под формой, а поле только отмечается.
*/
export function invalidClass(problem) {
  return problem ? 'field--invalid' : undefined
}
